import { joinClasses } from "@/utils/styling";

interface DateInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  type?: Exclude<React.HTMLInputTypeAttribute, "checkbox" | "radio" | "range">;
}

export default function DateInput({
  type = "date",
  className,
  style,
  ...attributes
}: DateInputProps) {
  return (
    <input
      {...attributes}
      type={type}
      className={joinClasses("form-control", className)}
      style={{
        ...style,
        paddingRight: "12px",
      }}
    />
  );
}
